import { useEffect } from 'react';

const useWindowScroll = (callback: () => void, callOnFirstRender: boolean = false) => {
  useEffect(() => {
    if (callOnFirstRender) {
      callback();
    }

    window.addEventListener('scroll', callback);

    return () => window.removeEventListener('scroll', callback);
  }, [callback, callOnFirstRender]);
};

export default useWindowScroll;
